import { isDefined } from '@/utils/isDefined';

// allow numbers and booleans too as they can be safely transformed to strings
export type Params = Record<string, string | number | boolean>;
export const addParamsToUrl = (url: string, params?: Params) => {
  if (params) {
    const paramEntries: [string, string][] = [];

    Object.entries(params).forEach(([key, value]) => {
      // ignore params that are undefined or null
      if (isDefined(value)) {
        paramEntries.push([key, String(value)]);
      }
    });

    if (paramEntries.length) {
      return `${url}?${new URLSearchParams(paramEntries)}`;
    }
  }

  return url;
};
